export const MODAL_HOST_ID = 'drahft-modal-root';

const ModalHost = () => {
  return <div id={MODAL_HOST_ID} />;
};

export default ModalHost;
